import { render, staticRenderFns } from "./LedgerInitialBalance.vue?vue&type=template&id=886e1810&scoped=true"
import script from "./LedgerInitialBalance.vue?vue&type=script&lang=js"
export * from "./LedgerInitialBalance.vue?vue&type=script&lang=js"
import style0 from "./LedgerInitialBalance.vue?vue&type=style&index=0&id=886e1810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "886e1810",
  null
  
)

export default component.exports